import React, { Component } from 'react';
import { images } from '../../settings';
import renderHTML from 'react-render-html';

import './SliderText.scss';

class SliderText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxitems: 0,
      items: [],
      color: 'blue',
			cActive: 0,
			componentHeight: '310px',
			descLines: 0
    };
    this.images = images;
  }

  componentDidMount = () => {
		const { items, color } = this.props;
		
    if (items) {
      this.setState({
				cActive: 0,
        maxitems: items.length,
        items: items,
        color: color,
      });
    }
  };

  componentDidUpdate = nextProps => {
		const { items, color } = this.props;


		if (items !== nextProps.items ) {
      this.setState({
				cActive: 0,
        maxitems: items.length,
				items: items,
				descLines: 0,
				componentHeight: '310px'
			});
			
			if (items.length > 0) {
				items.map((item, index) => {
					let descLines = item.descricao.split(/\r\n|\r|\n/).length;
					let height = `calc(calc(${descLines} * 20px) + 70px)`;
	
					if (index == 0 || descLines > this.state.descLines) {
						this.setState({
							descLines: descLines,
							componentHeight: height
						})
					}
				})
			}
		}

		if (color !== nextProps.color) {
      this.setState({
        color: color,
      });
		}
  };

  changeSliderPrev(item) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive`] = newIndex[`cActive`] - 1 < 0 ? newIndex[`items`].length - 1 : item - 1;
    this.setState(newIndex);
  }

  changeSliderNext(item) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive`] = newIndex[`cActive`] + 1 > newIndex[`items`].length - 1 ? 0 : item + 1;
    this.setState(newIndex);
  }

  render = () => {
    const { items, cActive, color, maxitems } = this.state;
		const sliderClasses = color ? ['slider-text', `slider-text--${color}`] : ['slider-text'];
		
		const actualSlide = (cActive < 10) ? `${cActive+1}` : `${cActive+1}`;
		const lastSlide = (maxitems < 10) ? `${maxitems}` : `${maxitems}`;

    return (
      <div className={sliderClasses.join(' ')}>

				<div className="slider-text--content">
					{/* <div className="slider-text--content" style={{height: this.state.componentHeight}}> */}
					{/* {items.map((item, index) => {
						return (
							<div key={index} className={`slider-text--item ${index == cActive ? ' active' : ''}`}>
								<h3>{renderHTML(item.titulo)}</h3>
								<p>{renderHTML(item.descricao)}</p>
							</div>
						);
					})} */}
					
					{
						items.length > 0 &&
						<div className={`slider-text--item active`}>
							<h3>{renderHTML(items[cActive].titulo)}</h3>
							<p>{renderHTML(items[cActive].descricao)}</p>
						</div>
					}
				</div>

        <div className="slider-text_c__nav">
					<div className="c__nav__button c__nav__button--prev" onClick={() => this.changeSliderPrev(cActive)}></div>
					<div className="c__nav__status">
							<b>{actualSlide}</b>/{lastSlide}
					</div>
					<div className="c__nav__button c__nav__button--next" onClick={() => this.changeSliderNext(cActive)}></div>
        </div>
      </div>
    );
  };
}

export { SliderText };
